import { Component, EventEmitter, Input, Output } from '@angular/core';

type CertificationActionButtonVariant = 'default' | 'danger';

@Component({
  selector: 'app-certification-action-button',
  standalone: false,
  templateUrl: './certification-action-button.component.html',
  styleUrl: './certification-action-button.component.scss'
})
export class CertificationActionButtonComponent {
  @Input() label = '';
  @Input() iconClass = '';
  @Input() variant: CertificationActionButtonVariant = 'default';
  @Input() disabled = false;
  @Output() pressed = new EventEmitter<void>();

  onPressed(): void {
    if (this.disabled) {
      return;
    }
    this.pressed.emit();
  }
}
